import { ICompanyCulture, ICultureListItem, ICompanyListItem } from './types';

export function sortCultureList(cultures: ICompanyCulture[]) {
  const culturesById: ICultureListItem[] = [];
  const companiesById: ICompanyListItem[] = [];

  cultures.forEach(cult => {
    const newCulture: ICultureListItem = {
      cultureId: cult.culture.id,
      cultureName: cult.culture.name,

      harvest: cult.harvest,
      area: cult.area,
    };

    const existingCulture = culturesById.find(
      culture => culture.cultureId === newCulture.cultureId,
    );
    if (existingCulture) {
      existingCulture.harvest += newCulture.harvest;
      existingCulture.area += newCulture.area;
    } else {
      culturesById.push(newCulture);
    }
  });

  cultures.forEach(cult => {
    const newCulture = {
      cultureId: cult.culture.id,
      cultureName: cult.culture.name,

      harvest: cult.harvest,
      area: cult.area,
    };

    const newCompany: ICompanyListItem = {
      id: cult.company.id,
      name: cult.company.name,
      cultures: [newCulture],
    };

    const existingCompany = companiesById.find(
      company => company.id === newCompany.id,
    );
    if (existingCompany) {
      existingCompany.cultures.push(newCulture);
    } else {
      companiesById.push(newCompany);
    }
  });

  return {
    cultures: culturesById,
    companies: companiesById,
  };
}
